<template>
  <div style="display: flex; flex-direction: column">
    <v-card-text><h2>Keeping CanvasPro running smoothly</h2></v-card-text>
    <v-card-text style="font-size: 1.1em">
      CanvasPro is built for mission-critical reliability. To help us ensure it
      continues to operate at peak performance and to proactively address any
      rare, unforeseen operational anomalies, we utilize anonymous system
      telemetry.
    </v-card-text>
    <v-card-text style="font-size: 1.1em">
      This system automatically collects only non-personal, system-level
      diagnostic data, such as error reports and performance metrics.
      <strong>
        No personal information like your name, email, or specific content you
        create is included in this telemetry.
      </strong>
      We use this data solely to help us identify and resolve issues before they
      impact your experience.
    </v-card-text>
    <v-card-text style="font-size: 1.1em">
      Accepting: Enables telemetry for your application's appearance and your
      interactions (frontend). If all other users also accept, telemetry for
      overall system health and stability (backend) will also be enabled for
      everyone.
    </v-card-text>
    <v-card-text style="font-size: 1.1em">
      Declining: Disables all telemetry (both frontend and backend) for your
      account. This will also prevent backend telemetry (system health and
      stability) from being enabled for any user, even if others have accepted.
    </v-card-text>
  </div>
</template>
<script setup lang="ts">
const props = defineProps(['customState', 'masterObj']);
</script>
<style scoped></style>
